import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import BaseFooter from '@layout/Footer/BaseFooter';
import AppContainer from '@layout/Components/AppContainer';
import SimpleHeader from '@layout/Header/SimpleHeader';
import { Spacings, mediaQuery } from '@styles/index';
import HeaderUserOptions from '@layout/Header/HeaderUserOptions';

const QuizLandingContainer = styled(AppContainer)`
  margin-top: ${Spacings.SPACING_10B};
  grid-auto-rows: max-content;

  ${mediaQuery.uptoTablet} {
    margin: ${Spacings.SPACING_4B} 0 0 0;
    padding: 0 ${Spacings.SPACING_2B};
    width: 100%;
    display: flex;
    flex-flow: column;
  }
`;

const BaseLayout = ({ children }) => (
  <>
    <SimpleHeader>
      <HeaderUserOptions />
    </SimpleHeader>
    <QuizLandingContainer>{children}</QuizLandingContainer>
    <BaseFooter display noFooter={false} />
  </>
);

BaseLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default BaseLayout;
